<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="roleform"
          status-icon
          :model="roleform"
          :rules="rules"
          label-width="120px"
          style="width: 90%;"
        >
          <el-form-item label="角色名" prop="RoleName">
            <el-input v-model="roleform.RoleName"></el-input>
          </el-form-item>
          <el-form-item label="父级角色" prop="ParentRoleName">
            <el-cascader
              v-model="roleform.ParentRoleId"
              :options="RoleOptions"
              :props="RoleoptionsProps"
              :show-all-levels="false"
              filterable
              @change="ParentRoleChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="备注" prop="Description">
            <el-input
              type="textarea"
              :rows="5"
              v-model="roleform.Description"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button type="primary" @click="Onsubmit('roleform')">提交</el-button>
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";

export default {
  name: "RoleInfoPage",
  data() {
    return {
      roleform: {
        RoleName: "",
        ParentRoleId: "",
        Description: "",
      },
      rules: {
        RoleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
      resData: "",
      OrgId: "",
      ParentRole: null,
      RoleOptions: [],
      RoleoptionsProps: {
        checkStrictly: true,
        emitPath: false,
      },
    };
  },
  props: {
    Role_Id: {
      type: String,
      default: "",
    },
    Org_Id: {
      type: String,
      default: "",
    },
  },
  created: function () {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      console.log(this.Org_Id);
      this.GetOrgObjByOrgCode();
    },
    Onsubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SaveData();
        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    GetInfo() {
      if (this.Role_Id) {
        showLoading(".zj-form-container");

        let RoleInfoSearch = {
          RoleId: this.Role_Id,
        };
        new WebApis.RoleApi()
          .GetItemById(RoleInfoSearch)
          .then((res) => {
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.roleform.RoleName = this.resData.RoleName;
              this.roleform.ParentRoleId = this.resData.ParentRoleId;
              this.GetRoleByRoleId(this.roleform.ParentRoleId);
              this.roleform.Description = this.resData.Description;
              this.Org_Id = this.resData.OrgId;
              hideLoading();
            }
          })
          .catch((e) => {
            hideLoading();
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取角色信息失败!" + e.RspMsg
                : "获取角色信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    GetRoleByRoleId(Role_Id) {
      let RoleInfoSearch = {
        RoleId: Role_Id,
      };

      new WebApis.RoleApi()
        .GetItemById(RoleInfoSearch)
        .then((res) => {
          this.ParentRole = res.data.Data;
        })
        .catch((e) => {
          console.log("获取角色信息失败!" + e.RspMsg);
        });
    },
    GetRoleTreeByOrgId(Org_Id) {
      let user = this.user;
      let userId = user.UserId;

      let RoleInfoSearch = {
        OrgId: Org_Id,
        UserId: userId,
      };

      new WebApis.TreeApi()
        .GetRoleTree(RoleInfoSearch)
        .then((res) => {
          this.RoleOptions = res.data.Data;

          this.GetInfo();
        })
        .catch((e) => {
          console.log("获取角色层级信息失败!" + e.RspMsg);
        });
    },
    SaveData() {
      let RoleInfoDTO = {
        Id: 0,
        RoleId: "",
        RoleName: this.roleform.RoleName,
        ParentRoleId: this.roleform.ParentRoleId,
        RoleTiers: "",
        AllowEdit: 0,
        AllowDelete: 0,
        Description: this.roleform.Description,
        Creater: this.user.UserName,
        CreateTime: new Date(),
        Modifier: this.user.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extend1: "",
        Extend2: "",
        OrgId: this.Org_Id,
      };

      if (this.resData) {
        RoleInfoDTO.Id = this.resData.Id;
        RoleInfoDTO.RoleId = this.resData.RoleId;
        RoleInfoDTO.AllowEdit = 0;
        RoleInfoDTO.AllowDelete = 0;
        RoleInfoDTO.Modifier = this.user.UserName;
        RoleInfoDTO.ModifyTime = new Date();
        RoleInfoDTO.Validity = 1;
        this.UpdateData(RoleInfoDTO);
      } else {
        this.InsertData(RoleInfoDTO);
      }
    },
    InsertData(RoleInfo) {
      new WebApis.RoleApi()
        .AddItem(RoleInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "角色添加成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "添加角色失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "角色添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "角色添加成功" : "角色添加失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "角色管理添加页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "添加角色失败！" + e.RspMsg : "添加角色失败！",
            type: "error",
          });
          return false;
        });
    },
    UpdateData(RoleInfo) {
      new WebApis.RoleApi()
        .UpdateItem(RoleInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "角色修改成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "修改角色失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "角色修改";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "角色修改成功" : "角色修改失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "角色管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "修改角色失败！" + e.RspMsg : "修改角色失败！",
            type: "error",
          });
          return false;
        });
    },
    GetOrgObjByOrgCode() {
      let Org_Code = this.CNF("app.Org_Code");
      let OrgInfoSearch = {
        OrgCode: Org_Code,
      };
      new WebApis.OrgApi()
        .FindByConditions(OrgInfoSearch)
        .then((res) => {
          if (res.RspCode == "1") {
            this.OrgId = res.data.Data[0].OrgId;

            this.GetRoleTreeByOrgId(this.OrgId);
          }
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "获取组织失败！" + e.RspMsg : "获取组织失败！",
            type: "error",
          });
        });
    },
    ParentRoleChange() {
      this.GetRoleByRoleId(this.roleform.ParentRoleId);
    },
  },
};
</script>

<style>
</style>